/* eslint-disable camelcase */
import {
    BBMConfigWithStats,
    BBMTag, BBMTaggedObject,
    CampaignsStateData,
    CampaignStatsItem,
} from './budget-manager.types';
import { BUDGET_MANAGER, LIFETIME_BUDGET } from './container/budget-manager.constants';


const getObjectHash = (object: BBMTaggedObject) => [
    object.platform,
    object.accountId,
    object.campaignId,
    object.subLevelId,
].join('-');

export const isObjectEquals = obj1 => obj2 => getObjectHash(obj1) === getObjectHash(obj2);

export const hasBBMTagsForObject = tags => tags.find(
    tag => tag.group_name === BUDGET_MANAGER && tag.tag !== 'untagged',
);

// eslint-disable-next-line camelcase
export const isExperimentCampaign = item => (
    // eslint-disable-next-line camelcase
    !!item?.base_campaign_id
    // eslint-disable-next-line camelcase
    && item?.base_campaign_id?.toString() !== item.campaign_id?.toString()
);

const isCampaignType = (item: CampaignStatsItem, type: string) => item.type === type;

// eslint-disable-next-line camelcase
const isLifetimeBudget = (item: CampaignStatsItem) => item?.budget_type === LIFETIME_BUDGET;

const isSharedBudget = (item: CampaignStatsItem) => (
    Boolean(item?.['is_budget_explicitly_shared'])
);
export const getIneligibleReason = (item: CampaignStatsItem) => {
    if (isExperimentCampaign(item)) return 'Experiment';
    if (isCampaignType(item, 'Express')) return 'Google Express';
    if (isLifetimeBudget(item)) return 'Lifetime Budget';
    if (isSharedBudget(item)) return 'Shared Budget';
    return undefined;
};

export const updateTaggedCampaigns = (
    campaigns: CampaignsStateData, clusters: BBMConfigWithStats,
) => campaigns?.items?.map(
    campaign => ({
        ...campaign,
        tags: setTagCampaing(
            campaign.tags,
            getTagCluster(clusters, campaign.campaign_id, campaign.sublevel_id),
        ),
    }),
);

function setTagCampaing(
    tags: { group_name: string; tag: string; }[], clusterTag: BBMTag | string,
): any {
    return tags.map((tag) => {
        if (tag.group_name === BUDGET_MANAGER) {
            return {
                ...tag,
                tag: clusterTag,
            };
        }
        return {
            ...tag,
        };
    });
}

function getTagCluster(
    clusters: BBMConfigWithStats,
    campaign_id: string,
    sublevel_id: string,
): BBMTag | string {
    return clusters.objects.find(
        object => (sublevel_id
            ? object.subLevelId === sublevel_id : object.campaignId === campaign_id),
    )?.tag || 'untagged';
}
